import React from 'react'
import loadable from '@components/loadable'
import PropTypes from 'prop-types'
const CapaList = loadable(() => import('@views/capa/partials/list'))
const CapaEdit = loadable(() => import('@views/capa/edit'))
const CapaImport = loadable(() => import('@views/capa/Import'))
const CapaCreate = loadable(() => import('@views/capa/Create'))
import {LoadComponent} from '../../lazy-loader'

const Capa = ({modalResolver, type, operation, data, ...remainingProps}) => {
  return (
    <>
      {operation === 'VIEW' && <CapaList type={type} {...remainingProps} fallback={LoadComponent} />}
      {operation === 'UPDATE' && <CapaEdit type={type} {...remainingProps} data={data} fallback={LoadComponent} />}
      {operation === 'IMPORT' && <CapaImport type={type} {...remainingProps} data={data} fallback={LoadComponent} />}
      {operation === 'CREATE' && <CapaCreate type={type} {...remainingProps} data={data} fallback={LoadComponent} />}
    </>
  )
}

Capa.propTypes = {
  modalResolver: PropTypes.func,
  type: PropTypes.string,
  data: PropTypes.object,
  operation: PropTypes.string,
  resouce: PropTypes.string,
  resourceId: PropTypes.string,
}

Capa.defaultProps = {
  title: 'Capa',
  type: 'CAPA',
  operation: 'CREATE',
  data: {},
}

export default Capa
